import * as Sentry from '@sentry/nextjs'
import React from 'react'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer'

import { ITeamCategoryHeaderProps } from '../_types/team-categories.types'

const ATeamCategoryHeader: React.FC<ITeamCategoryHeaderProps> = ({ title, description }) => {
	let titleFirstWord = ''
	let titleRest = ''

	try {
		titleFirstWord = title.split(' ')[0]
		titleRest = title.split(' ').slice(1).join(' ')
	} catch (error) {
		Sentry.captureException(error)

		titleFirstWord = title
	}

	return (
		<div className='box_complex-health_head'>
			<div className='anim_delay anim_drop1 observe'>
				<h2 className='title_h1 '>
					{(() => {
						return (
							<>
								{titleFirstWord}
								{titleRest.length > 0 && <br />}
								{titleRest}
							</>
						)
					})()}
				</h2>
				<div className='page_content reset_margins mgt-30 editorjs-team-category-header'>
					{/* <p>{description}</p> */}
					<ZEditorJsRenderer data={description} />
				</div>
			</div>
		</div>
	)
}

export default ATeamCategoryHeader
